import FontAwesome from 'react-fontawesome';

// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
export const WorkActionsContainer = ({ children }) => (
  <div className="wp-workCard_item wp-workCard--actions">{children}</div>
);

// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'href' implicitly has an 'any' typ... Remove this comment to see the full error message
const WorkAction = ({ href, onClick, icon, text }) => (
  <a href={href} onClick={onClick} className="wp-workCard--action">
    <FontAwesome name={icon} />
    <span>{text}</span>
  </a>
);

WorkAction.defaultProps = {
  href: 'javascript:void(0);',
};

// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'downloadUrl' implicitly has an 'a... Remove this comment to see the full error message
export const WorkActions = ({ downloadUrl, children }) => (
  <WorkActionsContainer>
    {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'onClick' is missing in type '{ icon: str... Remove this comment to see the full error message */}
    {downloadUrl && <WorkAction icon="arrow-down" text="Download" />}
    {children}
  </WorkActionsContainer>
);
